import { Pipe, PipeTransform } from '@angular/core';
import { CardEncodeType } from '../shared/models/Utilities/card-encode-type';

@Pipe({
  name: 'cardEncoderTypeEnumDescriptionPipe'
})
export class CardEncoderTypeEnumDescriptionPipe implements PipeTransform {

  transform(value: number): string {
    return CardEncodeType[value];
  }

}
